module.exports = __webpack_public_path__ + "img/05.c36fd9d4.jpg";